<!-- Dialogs -->
<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    title="Remove Integration?"
    description="Are you sure you want to delete this integration?"
    [negative]="true"
    [label]="'Delete'"
></app-deprecated-confirmation-dialog>

<!-- Forms -->
<app-deprecated-modal-form
    #indeedModal
    (save)="onCreate(indeedForm.model)"
    [form]="indeedForm"
    headerText="Manage Integration"
>
    <app-settings-indeed-form #indeedForm></app-settings-indeed-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #workableModal
    (save)="onCreate(workableForm.model)"
    [form]="workableForm"
    headerText="Manage Integration"
>
    <app-settings-workable-form #workableForm></app-settings-workable-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form #greenhouseModal (save)="onCreate(greenhouseForm.model)" headerText="Manage Integration">
    <app-settings-greenhouse-form #greenhouseForm></app-settings-greenhouse-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #jazzhrModal
    (save)="onCreate(jazzhrForm.model)"
    [form]="jazzhrForm"
    headerText="Manage Integration"
>
    <app-settings-jazzhr-form #jazzhrForm></app-settings-jazzhr-form>
</app-deprecated-modal-form>

<div class="page-container" [class.loading]="isLoading">
    <app-header title="Settings" [menuService]="settingsMenuService"></app-header>

    <div class="ui grid">
        <div class="ten wide column">
            <div *ngIf="!integrationPaginator.total" class="ui segment empty installed-apps">
                <app-segment-header title="Installed Apps"></app-segment-header>
                <img src="/assets/illustrations/empty-box.png" />
                <h2 class="ui centered header">No Apps Installed</h2>
            </div>

            <div *ngIf="integrationPaginator.total" class="ui segment installed-apps">
                <app-segment-header title="Installed Apps"></app-segment-header>
                <div class="ui three cards">
                    <div *ngFor="let item of integrationPaginator.values" class="card">
                        <mat-slide-toggle
                            color="primary"
                            [(ngModel)]="item.isEnabled"
                            (ngModelChange)="onToggle(item)"
                        ></mat-slide-toggle>
                        <div class="content">
                            <img [attr.src]="item.integrationType?.logo" />
                            {{ item.integrationType?.label }}
                            <div class="actions">
                                <ng-container [ngSwitch]="item.integrationType?.name">
                                    <a
                                        *ngSwitchCase="'indeed'"
                                        (click)="indeedForm.setId(item.integrationDetailId); indeedModal.show()"
                                    >
                                        Manage
                                    </a>
                                    <a
                                        *ngSwitchCase="'workable'"
                                        (click)="workableForm.setId(item.integrationDetailId); workableModal.show()"
                                    >
                                        Manage
                                    </a>
                                    <a
                                        *ngSwitchCase="'jazzhr'"
                                        (click)="jazzhrForm.setId(item.integrationDetailId); jazzhrModal.show()"
                                    >
                                        Manage
                                    </a>
                                    <a
                                        *ngSwitchCase="'greenhouse'"
                                        (click)="greenhouseForm.setId(item.integrationDetailId); greenhouseModal.show()"
                                    >
                                        Manage
                                    </a>
                                </ng-container>
                                &nbsp;|&nbsp;
                                <a class="delete" (click)="onDelete(item)">Delete</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="six wide column">
            <div class="ui segment available-apps">
                <app-segment-header title="Available Apps"></app-segment-header>
                <div class="ui one cards">
                    <div
                        *ngFor="let item of integrationTypePaginator.values"
                        class="card"
                        [class.disabled]="integrationTypeInUse(item)"
                    >
                        <div class="content">
                            <span class="logo">
                                <img [attr.src]="item.logo" />
                                {{ item.label }}
                            </span>
                            <ng-container [ngSwitch]="item.name">
                                <ui-button
                                    type="ghost"
                                    [disabled]="integrationTypeInUse(item)"
                                    *ngSwitchCase="'indeed'"
                                    (click)="indeedForm.reset(); indeedModal.show()"
                                    >Install</ui-button
                                >
                                <ui-button
                                    type="ghost"
                                    [disabled]="integrationTypeInUse(item)"
                                    *ngSwitchCase="'workable'"
                                    (click)="workableForm.reset(); workableModal.show()"
                                    >Install</ui-button
                                >
                                <ui-button
                                    type="ghost"
                                    [disabled]="integrationTypeInUse(item)"
                                    *ngSwitchCase="'greenhouse'"
                                    (click)="greenhouseForm.reset(); greenhouseModal.show()"
                                    >Install</ui-button
                                >
                                <ui-button
                                    type="ghost"
                                    [disabled]="integrationTypeInUse(item)"
                                    *ngSwitchCase="'jazzhr'"
                                    (click)="jazzhrForm.reset(); jazzhrModal.show()"
                                    >Install</ui-button
                                >
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
